import React from 'react';

import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import { doNothing } from 'src/helpers';

import { ConfirmationDialog, ConfirmationDialogVariant } from '../generic';

export const sessionTimeOutModalVar = makeVar(false);

export function SessionTimeOutModalProvider({
  children,
}: React.HTMLAttributes<HTMLElement>): JSX.Element {
  const isOpen = useReactiveVar(sessionTimeOutModalVar);

  return (
    <>
      {children}
      <SessionTimeOutModal isOpen={isOpen} />
    </>
  );
}

export function SessionTimeOutModal({ isOpen }: { isOpen: boolean }): JSX.Element {
  return (
    <ConfirmationDialog
      disableAltClose
      message="Your session has expired. Please refresh to continue."
      open={isOpen}
      primaryText="Refresh Session"
      showSecondary={false}
      title="Session Expired"
      variant={ConfirmationDialogVariant.Warn}
      onClickPrimary={() => window.location.reload()}
      onClose={doNothing}
    />
  );
}
